/**
 * Simply util to check if GA is ready to be used.
 */
const isGAReady = (): boolean =>
  typeof window !== 'undefined' &&
  Object.prototype.hasOwnProperty.call(window, 'ga');

export default isGAReady;
